import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _coverImage = {
    position: '_coverImagePosition',
    mobilePosition: '_coverImagePosition',
};
var _coverImagePosition = { x: 'FLOAT', y: 'FLOAT' };
var _createGroupRequest = { group: '_group' };
var _createGroupResponse = { group: '_group' };
var _deleteGroupRequest = {};
var _deleteGroupResponse = { group: '_group' };
var _getGroupBMFeaturesRequest = {};
var _getGroupBMFeaturesResponse = {};
var _getGroupBySlugRequest = {};
var _getGroupBySlugResponse = { group: '_group' };
var _getGroupIdBySlugRequest = {};
var _getGroupIdBySlugResponse = {};
var _getGroupRequest = {};
var _getGroupResponse = { group: '_group' };
var _group = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    recentActivityDate: 'google.protobuf.Timestamp',
    lastActivityDate: 'google.protobuf.Timestamp',
    details: '_groupDetails',
    coverImage: '_coverImage',
};
var _groupDetails = {
    logoPosition: '_position',
    mobileLogoPosition: '_position',
};
var _groupWithMsId = { groups: '_group' };
var _listGroupIntegrationsDataRequest = {};
var _listGroupIntegrationsDataResponse = {};
var _listGroupsByUserIdRequest = {};
var _listGroupsByUserIdResponse = { groups: '_groupWithMsId' };
var _listGroupsRequest = {};
var _listGroupsResponse = { groups: '_group' };
var _position = { x: 'FLOAT', y: 'FLOAT' };
var _queryGroupsByMembershipRequest = {};
var _queryGroupsByMembershipResponse = { groups: '_group' };
var _queryGroupsRequest = {};
var _queryGroupsResponse = { groups: '_group' };
var _queryJoinedGroupsRequest = {};
var _queryJoinedGroupsResponse = { groups: '_group' };
var _queryJoinedGroupsWithMemberRequest = {};
var _queryJoinedGroupsWithMemberResponse = { groups: '_group' };
var _updateGroupRequest = { group: '_group' };
var _updateGroupResponse = { group: '_group' };
function resolveWixSocialGroupsApiV2GroupsServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/groups-proxy',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/social-groups-proxy/groups',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/social-groups-proxy/groups',
                destPath: '',
            },
            {
                srcPath: '/_api/groups-proxy',
                destPath: '',
            },
        ],
        'editor-flow.wixapps.net': [
            {
                srcPath: '/_api/social-groups-proxy/groups',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/social-groups-proxy/groups',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/social-groups-proxy/groups',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/social-groups-proxy/groups',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/social-groups-proxy/groups',
                destPath: '',
            },
        ],
        'groups.wixapps.net': [
            {
                srcPath: '/_api/social-groups-proxy/groups',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/social-groups-proxy/groups',
                destPath: '',
            },
            {
                srcPath: '/social-groups-proxy/api/groups',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/social-groups-proxy/groups',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/social-groups-proxy/groups',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Creates a group.
 *
 * When a group is created, the newly created group is added to the [Groups List](https://support.wix.com/en/article/wix-groups-about-your-groups-pages#groups-group-list) page
 * of a site.
 *
 * Specify a `creatorId` to set the group's creator. The group's creator will automatically become a group admin, see Terminology ([REST](https://dev.wix.com/docs/rest/crm/community/groups/terminology) | [SDK](https://dev.wix.com/docs/sdk/backend-modules/groups/terminology)).
 *
 * Wix users determine who can create a group.
 * This setting can be found in [a site's Dashboard](https://www.wix.com/my-account/site-selector/?buttonText=Select%20Site&title=Select%20a%20Site&autoSelectOnSingleSite=true&actionUrl=https:%2F%2Fwww.wix.com%2Fdashboard%2F%7B%7BmetaSiteId%7D%7D%2Fwix-groups/settings?) under **Groups > General Settings > Group Creation**.
 * If set to **members with approval**, site members can create a group with the Create Group method, and the group becomes a `createRequest` with a status of `PENDING`.
 * A Wix user either approves or rejects the request to create a group.
 * If set to **all site members**, site members can create a group with the Create Group method and no approval is required.
 * If set to **only admins**, only Wix users can create a group with the Create Group method.
 * Default is set to **members with approval**.
 */
export function createGroup(payload) {
    var _a = serializer(_createGroupRequest, {
        _coverImage: _coverImage,
        _coverImagePosition: _coverImagePosition,
        _group: _group,
        _groupDetails: _groupDetails,
        _position: _position,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createGroupResponse, {
        _coverImage: _coverImage,
        _coverImagePosition: _coverImagePosition,
        _group: _group,
        _groupDetails: _groupDetails,
        _position: _position,
    }).fromJSON;
    function __createGroup(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v2.group',
            method: 'POST',
            methodFqn: 'wix.social.groups.api.v2.GroupsService.CreateGroup',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixSocialGroupsApiV2GroupsServiceUrl({
                protoPath: '/v2/groups',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createGroup.fromReq = fromReq;
    __createGroup.__isAmbassador = true;
    return __createGroup;
}
/**
 * Updates a group.
 *
 * When a public or private group's name is updated, the slug is updated to reflect the new group name.
 * Only group admins can update their group.
 *
 * > **Notes:**
 * > + When `group.privacyStatus` is updated from `PRIVATE` to `PUBLIC`, all pending group join requests are automatically approved.
 * > + When `group.privacyStatus` is updated from `PRIVATE` to `SECRET`, all pending group join requests are automatically rejected.
 */
export function updateGroup(payload) {
    var _a = serializer(_updateGroupRequest, {
        _coverImage: _coverImage,
        _coverImagePosition: _coverImagePosition,
        _group: _group,
        _groupDetails: _groupDetails,
        _position: _position,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateGroupResponse, {
        _coverImage: _coverImage,
        _coverImagePosition: _coverImagePosition,
        _group: _group,
        _groupDetails: _groupDetails,
        _position: _position,
    }).fromJSON;
    function __updateGroup(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v2.group',
            method: 'PATCH',
            methodFqn: 'wix.social.groups.api.v2.GroupsService.UpdateGroup',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixSocialGroupsApiV2GroupsServiceUrl({
                protoPath: '/v2/groups/{group.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateGroup.fromReq = fromReq;
    __updateGroup.__isAmbassador = true;
    return __updateGroup;
}
/**
 * Hides a group from the [Groups List](https://support.wix.com/en/article/wix-groups-about-your-groups-pages#groups-group-list) or cancels a group request.
 *
 * >**Notes:**
 * > + Only group admins can delete their group.
 * > + The group will no longer be visible in the live site or the dashboard.
 * > + It is not possible to restore a deleted group with the Update Group method.
 * > + It is still possible to retrieve the group with the Get Group, List Groups, and Query Groups methods.
 */
export function deleteGroup(payload) {
    var _a = serializer(_deleteGroupRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteGroupResponse, {
        _coverImage: _coverImage,
        _coverImagePosition: _coverImagePosition,
        _group: _group,
        _groupDetails: _groupDetails,
        _position: _position,
    }).fromJSON;
    function __deleteGroup(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v2.group',
            method: 'DELETE',
            methodFqn: 'wix.social.groups.api.v2.GroupsService.DeleteGroup',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixSocialGroupsApiV2GroupsServiceUrl({
                protoPath: '/v2/groups/{groupId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteGroup.fromReq = fromReq;
    __deleteGroup.__isAmbassador = true;
    return __deleteGroup;
}
/**
 * Retrieves a group.
 *
 * For groups with `group.privacyStatus` set to `SECRET`, only group admins and group members can see the group and its content.
 */
export function getGroup(payload) {
    var _a = serializer(_getGroupRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getGroupResponse, {
        _coverImage: _coverImage,
        _coverImagePosition: _coverImagePosition,
        _group: _group,
        _groupDetails: _groupDetails,
        _position: _position,
    }).fromJSON;
    function __getGroup(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v2.group',
            method: 'GET',
            methodFqn: 'wix.social.groups.api.v2.GroupsService.GetGroup',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixSocialGroupsApiV2GroupsServiceUrl({
                protoPath: '/v2/groups/{groupId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getGroup.fromReq = fromReq;
    __getGroup.__isAmbassador = true;
    return __getGroup;
}
/**
 * Retrieves a group by slug.
 *
 * The slug is the end of a group's URL that refers to a specific group.
 * For example, if a group's URL is `https:/example.com/groups/{my-fitness-group}`, the slug is `my-fitness-group`.
 * Slugs are case-sensitive. It is generally based on the group name, but for secret groups it is an autogenerated string of characters,
 * for example, `https:/example.com/groups/{5D3yTX}`.
 *
 * For groups with `group.privacyStatus` set to `SECRET`, only group admins and group members can see the group and its content.
 */
export function getGroupBySlug(payload) {
    var _a = serializer(_getGroupBySlugRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getGroupBySlugResponse, {
        _coverImage: _coverImage,
        _coverImagePosition: _coverImagePosition,
        _group: _group,
        _groupDetails: _groupDetails,
        _position: _position,
    }).fromJSON;
    function __getGroupBySlug(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v2.group',
            method: 'GET',
            methodFqn: 'wix.social.groups.api.v2.GroupsService.GetGroupBySlug',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixSocialGroupsApiV2GroupsServiceUrl({
                protoPath: '/v2/groups/slugs/{slug}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getGroupBySlug.fromReq = fromReq;
    __getGroupBySlug.__isAmbassador = true;
    return __getGroupBySlug;
}
/** Retrieves a group by slug. */
export function getGroupIdBySlug(payload) {
    var _a = serializer(_getGroupIdBySlugRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getGroupIdBySlugResponse, {}).fromJSON;
    function __getGroupIdBySlug(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v2.group',
            method: 'GET',
            methodFqn: 'wix.social.groups.api.v2.GroupsService.GetGroupIdBySlug',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixSocialGroupsApiV2GroupsServiceUrl({
                protoPath: '/v2/groups/slugs/{slug}/id',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getGroupIdBySlug.fromReq = fromReq;
    __getGroupIdBySlug.__isAmbassador = true;
    return __getGroupIdBySlug;
}
/**
 * Retrieves up to 100 groups.
 *
 * Default sorts by the created date in descending order.
 * For `SECRET` groups, only group admins and group members can see a list of groups and their content.
 */
export function listGroups(payload) {
    var _a = serializer(_listGroupsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listGroupsResponse, {
        _coverImage: _coverImage,
        _coverImagePosition: _coverImagePosition,
        _group: _group,
        _groupDetails: _groupDetails,
        _position: _position,
    }).fromJSON;
    function __listGroups(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v2.group',
            method: 'GET',
            methodFqn: 'wix.social.groups.api.v2.GroupsService.ListGroups',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixSocialGroupsApiV2GroupsServiceUrl({
                protoPath: '/v2/groups',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listGroups.fromReq = fromReq;
    __listGroups.__isAmbassador = true;
    return __listGroups;
}
/**
 * Retrieves a list of all groups user is member of from all sites. Expects Wix User authorization.
 * Used in My Activity widget inside of Spaces App
 * @deprecated
 */
export function listGroupsByUserId(payload) {
    var _a = serializer(_listGroupsByUserIdRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listGroupsByUserIdResponse, {
        _coverImage: _coverImage,
        _coverImagePosition: _coverImagePosition,
        _group: _group,
        _groupDetails: _groupDetails,
        _groupWithMsId: _groupWithMsId,
        _position: _position,
    }).fromJSON;
    function __listGroupsByUserId(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v2.group',
            method: 'GET',
            methodFqn: 'wix.social.groups.api.v2.GroupsService.ListGroupsByUserId',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixSocialGroupsApiV2GroupsServiceUrl({
                protoPath: '/v2/groups-by-user',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listGroupsByUserId.fromReq = fromReq;
    __listGroupsByUserId.__isAmbassador = true;
    return __listGroupsByUserId;
}
/**
 * Retrieves up to 100 groups, given the provided paging, filtering, and sorting.
 *
 * Supported fields for filtering:
 * - `title`
 *
 * Supported fields for sorting:
 * - `title`
 * - `createdDate`
 * - `membersCount`
 * - `recentActivityDate`
 *
 * For groups with `group.privacyStatus` set to `SECRET`, only group admins and group members can see the group and its content.
 */
export function queryGroups(payload) {
    var _a = serializer(_queryGroupsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryGroupsResponse, {
        _coverImage: _coverImage,
        _coverImagePosition: _coverImagePosition,
        _group: _group,
        _groupDetails: _groupDetails,
        _position: _position,
    }).fromJSON;
    function __queryGroups(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v2.group',
            method: 'POST',
            methodFqn: 'wix.social.groups.api.v2.GroupsService.QueryGroups',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixSocialGroupsApiV2GroupsServiceUrl({
                protoPath: '/v2/groups/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryGroups.fromReq = fromReq;
    __queryGroups.__isAmbassador = true;
    return __queryGroups;
}
/**
 * Retrieves groups that the current member has joined (deprecated, use `QueryGroupsByMembership`).
 * @deprecated
 */
export function queryJoinedGroups(payload) {
    var _a = serializer(_queryJoinedGroupsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryJoinedGroupsResponse, {
        _coverImage: _coverImage,
        _coverImagePosition: _coverImagePosition,
        _group: _group,
        _groupDetails: _groupDetails,
        _position: _position,
    }).fromJSON;
    function __queryJoinedGroups(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v2.group',
            method: 'POST',
            methodFqn: 'wix.social.groups.api.v2.GroupsService.QueryJoinedGroups',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixSocialGroupsApiV2GroupsServiceUrl({
                protoPath: '/v2/groups/query/joined',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryJoinedGroups.fromReq = fromReq;
    __queryJoinedGroups.__isAmbassador = true;
    return __queryJoinedGroups;
}
/** Retrieves groups by membership status for the current member. */
export function queryGroupsByMembership(payload) {
    var _a = serializer(_queryGroupsByMembershipRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryGroupsByMembershipResponse, {
        _coverImage: _coverImage,
        _coverImagePosition: _coverImagePosition,
        _group: _group,
        _groupDetails: _groupDetails,
        _position: _position,
    }).fromJSON;
    function __queryGroupsByMembership(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v2.group',
            method: 'POST',
            methodFqn: 'wix.social.groups.api.v2.GroupsService.QueryGroupsByMembership',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixSocialGroupsApiV2GroupsServiceUrl({
                protoPath: '/v2/groups-by-membership/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryGroupsByMembership.fromReq = fromReq;
    __queryGroupsByMembership.__isAmbassador = true;
    return __queryGroupsByMembership;
}
/** Returns general data about integrations (e.g. counts of events or topics) for specified group ids */
export function listGroupIntegrationsData(payload) {
    var _a = serializer(_listGroupIntegrationsDataRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listGroupIntegrationsDataResponse, {}).fromJSON;
    function __listGroupIntegrationsData(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v2.group',
            method: 'POST',
            methodFqn: 'wix.social.groups.api.v2.GroupsService.ListGroupIntegrationsData',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixSocialGroupsApiV2GroupsServiceUrl({
                protoPath: '/v2/groups/integrations',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listGroupIntegrationsData.fromReq = fromReq;
    __listGroupIntegrationsData.__isAmbassador = true;
    return __listGroupIntegrationsData;
}
export function getGroupBmFeatures(payload) {
    var _a = serializer(_getGroupBMFeaturesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getGroupBMFeaturesResponse, {}).fromJSON;
    function __getGroupBmFeatures(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v2.group',
            method: 'GET',
            methodFqn: 'wix.social.groups.api.v2.GroupsService.GetGroupBMFeatures',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixSocialGroupsApiV2GroupsServiceUrl({
                protoPath: '/v2/groups/{groupId}/bm-features',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getGroupBmFeatures.fromReq = fromReq;
    __getGroupBmFeatures.__isAmbassador = true;
    return __getGroupBmFeatures;
}
/** Retrieves groups that both the current member and specified member have joined. */
export function queryJoinedGroupsWithMember(payload) {
    var _a = serializer(_queryJoinedGroupsWithMemberRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryJoinedGroupsWithMemberResponse, { _coverImage: _coverImage, _coverImagePosition: _coverImagePosition, _group: _group, _groupDetails: _groupDetails, _position: _position }).fromJSON;
    function __queryJoinedGroupsWithMember(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v2.group',
            method: 'POST',
            methodFqn: 'wix.social.groups.api.v2.GroupsService.QueryJoinedGroupsWithMember',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixSocialGroupsApiV2GroupsServiceUrl({
                protoPath: '/v2/groups/query/joined-with-member',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryJoinedGroupsWithMember.fromReq = fromReq;
    __queryJoinedGroupsWithMember.__isAmbassador = true;
    return __queryJoinedGroupsWithMember;
}
//# sourceMappingURL=http.impl.js.map